import BlogComment from ".";


export const blogCommentRoutes = () => [
  {
    path: "/admin/blog-comments",
    component: BlogComment,
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
];
